<template>
  <v-tour name="myTour" :steps="steps" :options="tourOptions" :callbacks="myCallbacks">
    <template slot-scope="tour">
    <transition name="fade">
      <v-step
        :step="tour.steps[tour.currentStep]"
        v-if="tour.steps[tour.currentStep]"
        :key="tour.currentStep"
        :previous-step="tour.previousStep"
        :next-step="tour.nextStep"
        :stop="tour.stop"
        :skip="tour.skip"
        :is-first="tour.isFirst"
        :is-last="tour.isLast"
        :labels="tour.labels"
        style="background: #fff; box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1); filter:none; border-radius:7px; text-align:left;"
        class="pa-4"
      >
        <template v-if="tour.currentStep === 0">
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  skip
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" class="tinybut white--text text-none" depressed small @click="tour.nextStep">
                  next
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else-if="tour.currentStep === 3">
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="primary" class="mr-1 tinybut white--text text-none" depressed small @click="tour.previousStep">
                  prev
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  finish
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <template v-else>
          <div slot="content" class="relative">
            <span class="steps-count">{{tour.currentStep +  1}}/{{tour.steps.length}}</span>
            <div v-html="tour.steps[tour.currentStep].content"></div>
          </div>
          <div slot="actions">
            <v-layout>
              <v-flex>
                <v-btn color="error" class="mr-1 tinybut white--text text-none" depressed small @click="stopTour">
                  skip
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" class="mr-1 tinybut white--text text-none" depressed small @click="tour.previousStep">
                  prev
                </v-btn>
                <v-btn color="primary" class="tinybut white--text text-none" depressed small @click="tour.nextStep">
                  next
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </template>
      </v-step>
    </transition>
  </template>
  </v-tour>
</template>

<script>
export default {
  name: 'InvoiceTour',
  data () {
    return {
      tourOptions: {
        labels: {
          buttonSkip: 'Skip',
          buttonPrevious: 'Back',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      steps: [
        {
          target: '[data-v-step="savebut"]',
          content: '<h2 class="pb-2 fadegrey--text">Send</h2><p>Click the Send button to begin sending your invoice or click download to get a PDF.</p>',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-step="savebut"]',
          content: '<h2 class="pb-2 fadegrey--text">More options</h2><p>Click the dropdown arrow for more options.</p>',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '[data-v-step="timeline"]',
          content: '<h2 class="pb-2 fadegrey--text">Timeline</h2><p>Track the progress of your invoice on the timeline all the way from created to paid.</p>'
        },
        {
          target: '[data-v-step="editpanel"]',
          content: '<h2 class="pb-2 fadegrey--text">Edit</h2><p>Edit the invoice\'s details in these panels.</p>'
        }
      ],
      myCallbacks: {
        onNextStep: this.nextStepCallback,
        onPreviousStep: this.previousStepCallback
      }
    }
  },
  methods: {
    nextStepCallback (currentStep) {
      const thisStep = currentStep + 1
      if (thisStep === 1) {
        this.$emit('openDropdownMenu')
      } else {
        this.$emit('closeDropdownMenu')
      }
      if (thisStep === 3) {
        this.$emit('gotoTab', 'edit')
      } else {
        this.$emit('gotoTab', 'timeline')
      }
    },
    previousStepCallback (currentStep) {
      const thisStep = currentStep - 1
      if (thisStep === 1) {
        this.$emit('openDropdownMenu')
      } else {
        this.$emit('closeDropdownMenu')
      }
      if (thisStep === 3) {
        this.$emit('gotoTab', 'edit')
      } else {
        this.$emit('gotoTab', 'timeline')
      }
    },
    startTour () {
      this.$tours['myTour'].start()
      this.$emit('gotoTab', 'timeline')
    },
    stopTour () {
      this.$tours['myTour'].stop()
    }
  }
}
</script>

<style lang="scss">
.v-step{
  z-index:9999;
  border:1px solid #ccc;
  box-shadow: rgba(0, 22, 39, 0.46) 0px 0px 3000px 3000px !important;
}
.v-step{
  h2{
    color:var(--dark-text);
  }
  p{
    font-size:.9rem;
    font-weight:500;
    color:var(--dark-text);
  }
  span {
    color:var(--light-text);

  }
}

.v-step{
  button{
    font-size: 13px;
  }
}
.v-step__arrow{
  border-color:#fff !important;
}
.v-step[x-placement^=bottom] .v-step__arrow{
  border-left-color:transparent !important;
  border-right-color:transparent !important;
  border-top-color:transparent !important;
  border-bottom-color:#fff !important;
}
.v-step[x-placement^=top] .v-step__arrow{
  border-left-color:transparent !important;
  border-right-color:transparent !important;
  border-bottom-color:transparent !important;
  border-top-color:#fff !important;
}
</style>
